import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import { AuthProvider } from './contexts/AuthContext';
import ProtectedRoute from './components/layout/ProtectedRoute';
import PublicRoute from './components/layout/PublicRoute';
import Layout from './components/layout/Layout';

// Auth pages
import LoginPage from './pages/auth/LoginPage';

// Dashboard
import DashboardPage from './pages/dashboard/DashboardPage';

// Layout pages
import LayoutsPage from './pages/layouts/LayoutsPage';
import LayoutDetailPage from './pages/layouts/LayoutDetailPage';
import CreateLayoutPage from './pages/layouts/CreateLayoutPage';

// Plot pages  
import PlotsPage from './pages/plots/PlotsPage';
import PlotDetailPage from './pages/plots/PlotDetailPage';
import BookingPage from './pages/booking/BookingPage';

// Report pages
import ReportsPage from './pages/reports/ReportsPage';
import LayoutReportPage from './pages/reports/LayoutReportPage';
import RevenueReportPage from './pages/reports/RevenueReportPage';

// User pages
import UsersPage from './pages/users/UsersPage';

// Profile page
import ProfilePage from './pages/auth/ProfilePage';

// 404 page
import NotFoundPage from './pages/NotFoundPage';

function App() {
  return (
    <AuthProvider>
      <Router>
        <div className="App">
          <Routes>
            {/* Public routes (accessible when not authenticated) */}
            <Route 
              path="/login" 
              element={
                <PublicRoute>
                  <LoginPage />
                </PublicRoute>
              } 
            />

            {/* Protected routes (require authentication) */}
            <Route 
              path="/" 
              element={
                <ProtectedRoute>
                  <Layout />
                </ProtectedRoute>
              }
            >
              {/* Dashboard */}
              <Route index element={<DashboardPage />} />
              <Route path="dashboard" element={<DashboardPage />} />

              {/* Layouts */}
              <Route path="layouts" element={<LayoutsPage />} />
              <Route path="layouts/new" element={<CreateLayoutPage />} />
              <Route path="layouts/:id" element={<LayoutDetailPage />} />

              {/* Plots */}
              <Route path="plots" element={<PlotsPage />} />
              <Route path="plots/:id" element={<PlotDetailPage />} />
              <Route path="booking" element={<BookingPage />} />

              {/* Reports */}
              <Route path="reports" element={<ReportsPage />} />
              <Route path="reports/layout/:id" element={<LayoutReportPage />} />
              <Route path="reports/revenue" element={<RevenueReportPage />} />

              {/* Users (Admin only) */}
              <Route path="users" element={<UsersPage />} />

              {/* Profile */}
              <Route path="profile" element={<ProfilePage />} />

              {/* 404 */}
              <Route path="*" element={<NotFoundPage />} />
            </Route>

            {/* Redirect root to dashboard if authenticated */}
            <Route path="/" element={<Navigate to="/dashboard" replace />} />
          </Routes>
        </div>
      </Router>
    </AuthProvider>
  );
}

export default App;
